import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { hasPermission } from '../utils/permissions';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user, isAuthenticated } = useSelector(state => state.auth);
  if (!isAuthenticated) return <Navigate to='/' />;
  
  // Allow access if user is an anchor (userType === 1 or 'anchor')
  // This bypasses specific permission checks for anchor users
  const isAnchor = user?.userType === 1 || user?.userType === 'anchor';
  if (isAnchor) return children;

  if (!hasPermission(user, requiredPermission)) return <Navigate to='/unauthorized' />;
  return children;
};

export default ProtectedRoute; 